<template>
  <div class="jtCardDefault">
    <div class="jtCardDefault">
      <div id="topBar">
        <q-btn color="secondary"
          icon="mdi-filter-variant" @click="() => $emit('filter-button')"
          :label="$gettext('FILTER')"
          class="filter-button row"/>
      </div>
      <div id="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'JtCardDefault',
  props: {

  }
})
export default class JtCardDefault extends Vue {
  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.jtCardDefault {
  width: 100%;
  height: 100%;

  #topBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
  }

  #content {
    width: 100%;
    height: calc(100% - 30px);
  }

  .filter-button  {
    justify-content: end;
  }
}

</style>
